<div class="toolbar" *ngIf="canDelete()">
  <p-button
    label="Eliminar seleccionados"
    severity="danger"
    (click)="deleteSelected()"
    *ngIf="selectedRecords?.length"
  ></p-button>
</div>

<p-table
  [value]="records"
  styleClass="p-datatable-striped"
  sortMode="single"
  [(selection)]="selectedRecords"
  dataKey="id"
  [paginator]="true"
  [rows]="20"
  [rowsPerPageOptions]="[5, 10, 20, 50]"
  [lazy]="true"
  (onLazyLoad)="loadRecords($event)"
  [totalRecords]="totalRecords"
  [sortField]="'createdAt'"
  [sortOrder]="-1"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem" id="header-checkbox" *ngIf="canDelete()"></th>

      <th pSortableColumn="username" id="header-username">
        Usuario <p-sortIcon field="username"></p-sortIcon>
        <p-columnFilter
          field="username"
          matchMode="contains"
          display="menu"
          [showOperator]="false"
          [showAddButton]="false"
          [showMatchModes]="false"
        ></p-columnFilter>
      </th>
      <th pSortableColumn="categoryId" id="header-categoryId">
        Categoría <p-sortIcon field="categoryId"></p-sortIcon>
        <p-columnFilter
          field="category.name"
          matchMode="contains"
          display="menu"
          [showOperator]="false"
          [showAddButton]="false"
          [showMatchModes]="false"
        ></p-columnFilter>
      </th>
      <th pSortableColumn="comment" id="header-comment">
        Descripción <p-sortIcon field="title"></p-sortIcon>
        <p-columnFilter
          field="comment"
          matchMode="contains"
          display="menu"
          [showOperator]="false"
          [showAddButton]="false"
          [showMatchModes]="false"
        ></p-columnFilter>
      </th>
      <th pSortableColumn="createdAt" id="header-createdAt">
        Creado <p-sortIcon field="createdAt"></p-sortIcon>
      </th>
      <th id="header-file">Adjunto</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-record>
    <tr>
      <td *ngIf="canDelete()">
        <div class="row-buttons">
          <p-tableCheckbox [value]="record"></p-tableCheckbox>
        </div>
      </td>
      <td>{{ record.username }}</td>
      <td>{{ record.category?.name }}</td>
      <td>{{ record.comment }}</td>
      <td>{{ record.createdAt | date : "dd MMM yyyy, HH:mm" }}</td>
      <td>{{ record.file }}</td>
    </tr>
  </ng-template>
</p-table>
